import React, { Component } from 'react';
import {CSVLink} from 'react-csv';
import SpinnerSmall from './SpinnerSmall';
export default class ReportHeader extends Component {
  render() {
    return (
      <div className="report-header">
        <div><h4>{this.props.title}</h4></div>
        {this.props.hideAction ? null
          :
          this.props.csvLoading ?
            <div className="d-flex btn btn-primary disabled mr-05">
              <div className="color-white mr-05"><span>Loading CSV</span></div>
              <SpinnerSmall />
            </div>
          :
            this.props.fromFile2 ?
              <div className={this.props.actionClass}>
                  <div className="color-white mr-05" onClick={this.props.loadCsv}><span>{this.props.actionTitle}</span></div>
              </div>
            :
              <CSVLink className={this.props.actionClass}
                       filename={this.props.filename}
                       headers={this.props.headers}
                       data={this.props.csvData}>{this.props.actionTitle}
             </CSVLink>
       }
        {this.props.hideAction ? null
          :
          this.props.csvLoading2 ?
            <div className="d-flex btn btn-primary disabled mr-05">
              <div className="color-white mr-05"><span>Loading CSV</span></div>
              <SpinnerSmall />
            </div>
          :
            this.props.fromFile2 ?
              <div className={this.props.actionClass}>
                  <div className="color-white mr-05" onClick={this.props.loadCsv2}><span>{this.props.actionTitle2}</span></div>
              </div>
            :
              <CSVLink className={this.props.actionClass}
                       filename={this.props.filename2}
                       headers={this.props.headers2}
                       data={this.props.csvData2}>{this.props.actionTitle2}
             </CSVLink>
       }
       {this.props.tercer_csv ?
         this.props.csvLoading3 ?
           <div className="d-flex btn btn-primary disabled mr-05">
             <div className="color-white mr-05"><span>Loading CSV</span></div>
             <SpinnerSmall />
           </div>
         :
           this.props.fromFile3 ?
             <div className={this.props.actionClass}>
                 <div className="color-white mr-05" onClick={this.props.loadCsv3}><span>{this.props.actionTitle3}</span></div>
             </div>
           :
             <CSVLink className={this.props.actionClass}
                      filename={this.props.filename3}
                      headers={this.props.headers3}
                      data={this.props.csvData3}>{this.props.actionTitle3}
            </CSVLink>
         :
         null
      }
      </div>
    )
  }
}
